import CONSTANTS from '../constants';

export function setOrderId(orderId) {
  return async (dispatch) => {
    try {
      dispatch({ type: CONSTANTS.ACTIONS.ORDER_PREFERENCE.SET_ORDER_PREF_ID, data: orderId });
    } catch (error) {
      console.log('Error: ', error);
    }
  };
}

export function setOrderType(orderType) {
  return async (dispatch) => {
    try {
      dispatch({ type: CONSTANTS.ACTIONS.ORDER_PREFERENCE.SET_ORDER_PREF_TYPE, data: orderType });
    } catch (error) {
      console.log('Error: ', error);
    }
  };
}

export function setOrderCartState(cartState) {
  return async (dispatch) => {
    try {
      dispatch({
        type: CONSTANTS.ACTIONS.ORDER_PREFERENCE.SET_ORDER_PREF_CART_STATE,
        data: cartState
      });
    } catch (error) {
      console.log('Error: ', error);
    }
  };
}
